'use client';

import ErrorPage from '@components/ErrorPage/ErrorPage';
import {Route} from '@config/routes';
import {useLocale} from '@hooks/useLocale';
import {getPrependLocale} from '@utils/prependLocale';
import {useTranslations} from 'next-intl';

const Page404 = () => {
    const t = useTranslations('error404');
    const locale = useLocale();
    const prependLocale = getPrependLocale(Route.HOME, locale);

    const goHome = () => {
        if (prependLocale) {
            window.location.href = prependLocale;
        }
    };

    return (
        <ErrorPage
            body={t('body')}
            title="404"
            buttonLabel={t('button')}
            buttonIcon="home"
            onClick={goHome}
        />
    );
};

export default Page404;
